import {
	RESET_STATE,
	SET_CAR_TYPES,
	SET_CARS_LIST,
	SET_IS_CAR_TYPES_LOADING,
	SET_IS_DOWNLOAD_LOADING,
	SET_IS_CARS_LIST_LOADING,
	SET_PAGINATION,
	SET_TABLE_SEARCH,
} from './actions';

export const initialState = {
	carsList: null,
	isCarsListLoading: false,
	pagination: null,
	tableSearch: '',
	carTypes: null,
	isCarTypesLoading: false,
	isDownloadLoading: false,
};

const carsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_CARS_LIST:
			return {
				...state,
				carsList: payload,
			};
		case SET_IS_CARS_LIST_LOADING:
			return {
				...state,
				isCarsListLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_TABLE_SEARCH:
			return {
				...state,
				tableSearch: payload,
			};
		case SET_CAR_TYPES:
			return {
				...state,
				carTypes: payload,
			};
		case SET_IS_CAR_TYPES_LOADING:
			return {
				...state,
				isCarTypesLoading: payload,
			};
		case SET_IS_DOWNLOAD_LOADING:
			return {
				...state,
				isDownloadLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default carsContainerReducer;
